<template>
  <div
    class="modal__container"
    :class="{ 'reveal--modal': show }"
    @mousedown="$emit('close')"
  >
    <div
      class="modal__body"
      ref="modalBody"
      :class="[...bodyClass]"
      @mousedown.stop
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: [Array, String],
    },
  },
  watch: {
    show: function (val) {
      if (!val) {
        this.$refs.modalBody.scrollTop = 0;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/helpers/ModalComponent.vue